import PropTypes from "prop-types"
import React, { useRef, useState } from "react"
import { Badge, Button, Col, Modal, ModalBody, Row, Spinner } from "reactstrap"
import { FaDownload } from "react-icons/fa"
import ChallanReceiptContent from "./challanReceiptConntent"

const ChallanModal = ({ show, onCloseClick, updateData }) => {
  const printRef = useRef()
  const [loading, setLoading] = useState(false)

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="lg">
      <div>
        <Button
          close
          aria-label="Close"
          onClick={onCloseClick}
          style={{
            position: "absolute",
            right: "0rem",
            top: "0rem",
            zIndex: 10,
          }}
        />

        <ModalBody size="md" className="" style={{ paddingBottom: "0px" }}>
          <Row className="justify-content-center">
            <Col lg="7" md="10" sm="12" xs="12" className="px-0">
              <Row
                className="justify-content-center"
                style={{
                  marginTop: updateData?.certificate_image?.url
                    ? "-30px"
                    : "-20px",
                }}
              >
                <Col md="12" className="px-0" style={{ marginBottom: "0px" }}>
                  <ChallanReceiptContent
                    ref={printRef}
                    challanData={updateData}
                  />
                </Col>
              </Row>
              <div className=" px-2" style={{ marginTop: "6px" }}>
                <Row className="justify-content-between align-center px-0 py-3">
                  <div style={{ width: "fit-content" }}>
                    Status:
                    <Badge
                      className={`font-size-12 badge-soft-${
                        updateData?.status === "PENDING"
                          ? "info"
                          : updateData?.status === "FAILED"
                          ? "danger"
                          : "success"
                      } mx-2 `}
                      color=""
                      pill
                    >
                      {updateData?.status?.charAt(0)?.toUpperCase() +
                        updateData?.status?.slice(1)?.toLowerCase()}
                    </Badge>
                  </div>
                  {updateData?.status === "SUCCESS" &&
                    updateData?.certificate_image?.url && (
                      <>
                        <Button
                          size="md"
                          style={{ width: "fit-content" }}
                          onClick={async () => {
                            setLoading(true)

                            try {
                              const imageUrl =
                                updateData?.certificate_image?.url
                              const fileName = "Challan_Receipt.jpg"

                              const response = await fetch(imageUrl, {
                                mode: "cors",
                              })
                              const blob = await response.blob()

                              const blobUrl = window.URL.createObjectURL(blob)
                              const link = document.createElement("a")
                              link.href = blobUrl
                              link.download = fileName
                              document.body.appendChild(link)
                              link.click()
                              document.body.removeChild(link)
                              window.URL.revokeObjectURL(blobUrl)

                              setLoading(false)
                            } catch (error) {
                              console.error("Download error:", error)
                              setLoading(false)
                            }
                          }}
                          color="warning"
                          className="rounded-pill px-3 text-white "
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <Spinner size="sm" className="me-2" />{" "}
                              Downloading...
                            </>
                          ) : (
                            <>
                              <FaDownload className="me-1" /> Download Receipt
                            </>
                          )}
                        </Button>
                      </>
                    )}
                </Row>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </div>
    </Modal>
  )
}

ChallanModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default ChallanModal
